import React from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { FilterList } from "@material-ui/icons";
import moment from "moment-timezone";
import { useFilterStyles } from "./styles/styles";

const timezone = "America/Fortaleza";


const isYMD = (s) => typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s);

const toYMD = (v) => {
  if (!v) return undefined;
  if (isYMD(v)) return v;

  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T/.test(v)) {

    if (/[Zz]|[+\-]\d{2}:\d{2}$/.test(v)) {

      const m = moment.parseZone(v).tz(timezone);
      return m.isValid() ? m.format("YYYY-MM-DD") : undefined;
    }

    const m = moment(v);
    return m.isValid() ? m.format("YYYY-MM-DD") : undefined;
  }

  const m = moment(v);
  return m.isValid() ? m.format("YYYY-MM-DD") : undefined;
};

export default function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  disabled = false,
  className,
}) {
  const classes = useFilterStyles();

  const startYMD = toYMD(startDate) || "";
  const endYMD = toYMD(endDate) || "";

  const invalid = !startYMD || (endYMD && startYMD > endYMD);

  return (
    <Grid container spacing={2} className={`${classes.filter} ${className || ""}`}>
      <Grid item xs={12} md="auto">
        <TextField
          id="start-date"
          label="Data inicial"
          variant="outlined"
          type="date"
          value={startYMD}
          onChange={(e) => onStartDateChange(toYMD(e.target.value))}
          InputLabelProps={{ shrink: true }}
          size="small"
          className={classes.textField}
          error={invalid}
          helperText={
            (!startYMD && "Campo obrigatório") ||
            (endYMD && startYMD > endYMD && "Data inicial não pode ser maior que a final") ||
            " "
          }
          inputProps={{ max: endYMD || undefined, style: { padding: "10px 12px" } }}
        />
      </Grid>

      <Grid item xs={12} md="auto">
        <TextField
          id="end-date"
          label="Data final"
          variant="outlined"
          type="date"
          value={endYMD}
          onChange={(e) => onEndDateChange(toYMD(e.target.value))}
          InputLabelProps={{ shrink: true }}
          size="small"
          className={classes.textField}
          inputProps={{ min: startYMD || undefined, style: { padding: "10px 12px" } }}
        />
      </Grid>

      <Grid item xs={12} md="auto">
        <Button
          aria-label="filtrar"
          variant="contained"
          color="primary"
          onClick={() =>
            onApply?.({
              startDate: startYMD || undefined,
              endDate: endYMD || startYMD || undefined,
            })
          }
          startIcon={<FilterList />}
          className={classes.filterButton}
          fullWidth
          disabled={disabled || invalid}
        >
          Filtrar
        </Button>
      </Grid>
    </Grid>
  );
}
